import Dashboard from './Dashboard';
import * as Funnels from './Funnels';
import * as Goals from './Goals';
import Opportunities from './Opportunities';
import OpportunityDetails from './OpportunityDetails';
import * as Reasons from './Reasons';

export default {
  Reasons,
  Funnels,
  Opportunities,
  OpportunityDetails,
  Dashboard,
  Goals,
};
